import { useForm } from 'react-hook-form';
import { valueEmpty } from 'helpers';
import type { FormValues } from './boatFormTypes';

export const areAddressValuesMissing = (
  formValues: FormValues,
  errors: ReturnType<typeof useForm<FormValues>>['errors']
) => {
  const requiredFields = ['address', 'street_1', 'city', 'state', 'postal_code', 'country_code'];

  const isMissingFields: boolean = requiredFields.some((field) => valueEmpty(formValues[field]));
  if (isMissingFields) return true;

  const isUS = formValues.country_code === 'US';
  const missingStreetNumber = Boolean(errors.street_number);
  if (isUS && missingStreetNumber) return true;

  return false;
};
